<template>
  <Select v-model="abc" style="width: 100%" @on-select="selectFlow">
    <Option
      :value="y.id"
      v-for="(y, index1) in flowList"
      :key="index1"
      :label="y.name"
    >
      <span>{{ y.name }}</span>
    </Option>
  </Select>
</template>
<script>
export default {
  props: ["abc"],
  data() {
    return {
      flowList: [],
    };
  },
  methods: {
    getFlowList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.flow + "/flowConfig/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.flowList = data;
      });
    },
    selectFlow(v) {
      console.log(v);
      this.$emit("abc", v.value);
      this.$emit("flows", v);
    },
  },
  mounted() {
    this.getFlowList();
  },
  model: {
    prop: "abc",
    event: "abc",
  },
};
</script>


// WEBPACK FOOTER //
// src/components/yhgl/selectFlow.vue